export const CropInformationDefaultDataSet = {
  langMap: [
    {
      langCode: "en",
      name: "",
      summary: "",
      // optimalPlantingCondition: "",
      generalTips: "",
      soil: {
        optimalSoilPH: {
          min: "1",
          max: "7",
        },
        summary: "",
      },
      pest: {
        summary: "",
      },
      disease: {
        summary: "",
      },
      interCropping: [
        {
          displayOrder: 1,
          //minDaysSincePlanting: "",
          // maxDaysSincePlanting: "",
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
        },
      ],
      soilAndLandPreparation: [
        {
          displayOrder: 1,
          //minDaysSincePlanting: "",
          // maxDaysSincePlanting: "",
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
        },
      ],
      optimalPlantingCondition: [
        {
          displayOrder: 1,
          //minDaysSincePlanting: "",
          // maxDaysSincePlanting: "",
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
        },
      ],
      planting: [
        {
          displayOrder: 1,
          //minDaysSincePlanting: "",
          // maxDaysSincePlanting: "",
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
        },
      ],
      growing: [
        {
          displayOrder: 1,
          //minDaysSincePlanting: "",
          // maxDaysSincePlanting: "",
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
        },
      ],
      irrigation: [
        {
          displayOrder: 1,
          //minDaysSincePlanting: "",
          // maxDaysSincePlanting: "",
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
        },
      ],
      weeding: [
        {
          displayOrder: 1,
          // minDaysSincePlanting: "",
          // maxDaysSincePlanting: "",
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
        },
      ],
      fertilizer: [
        {
          displayOrder: 1,
          // minDaysSincePlanting: "",
          // maxDaysSincePlanting: "",
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
        },
      ],
      harvest: [
        {
          displayOrder: 1,
          //minDaysSincePlanting: "",
          // maxDaysSincePlanting: "",
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
        },
      ],
      postHarvest: [
        {
          displayOrder: 1,
          //minDaysSincePlanting: "",
          // maxDaysSincePlanting: "",
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
        },
      ],
      storageAndTransport: [
        {
          displayOrder: 1,
          //minDaysSincePlanting: "",
          // maxDaysSincePlanting: "",
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
        },
      ],
    },
  ],
};

export const newCropLangTemplate = {
  name: "",
  summary: "",
  // optimalPlantingCondition: "",
  generalTips: "",
  soil: {
    optimalSoilPH: {
      min: "1",
      max: "7",
    },
    summary: "",
  },
  pest: {
    summary: "",
  },
  disease: {
    summary: "",
  },
  interCropping: [
    {
      displayOrder: 1,
      //minDaysSincePlanting: "",
      // maxDaysSincePlanting: "",
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
    },
  ],
  soilAndLandPreparation: [
    {
      displayOrder: 1,
      //minDaysSincePlanting: "",
      // maxDaysSincePlanting: "",
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
    },
  ],
  optimalPlantingCondition: [
    {
      displayOrder: 1,
      //minDaysSincePlanting: "",
      // maxDaysSincePlanting: "",
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
    },
  ],
  planting: [
    {
      displayOrder: 1,
      // minDaysSincePlanting: "",
      // maxDaysSincePlanting: "",
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
    },
  ],
  growing: [
    {
      displayOrder: 1,
      // minDaysSincePlanting: "",
      // maxDaysSincePlanting: "",
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
    },
  ],
  irrigation: [
    {
      displayOrder: 1,
      // minDaysSincePlanting: "",
      // maxDaysSincePlanting: "",
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
    },
  ],
  weeding: [
    {
      displayOrder: 1,
      // minDaysSincePlanting: "",
      // maxDaysSincePlanting: "",
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
    },
  ],
  fertilizer: [
    {
      displayOrder: 1,
      // minDaysSincePlanting: "",
      // maxDaysSincePlanting: "",
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
    },
  ],
  harvest: [
    {
      displayOrder: 1,
      // minDaysSincePlanting: "",
      // maxDaysSincePlanting: "",
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
    },
  ],
  postHarvest: [
    {
      displayOrder: 1,
      // minDaysSincePlanting: "",
      // maxDaysSincePlanting: "",
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
    },
  ],
  storageAndTransport: [
    {
      displayOrder: 1,
      // minDaysSincePlanting: "",
      // maxDaysSincePlanting: "",
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
    },
  ],
};
